import classes from './Details.module.sass'
import { PriceDocumentInterface } from '../../../../../common/types/interfaces'
import { format } from 'date-fns'
import { PriceDocumentType } from '../../../../../common/types/enums'

type Props = {
  el?: PriceDocumentInterface
}

export const Details = ({ el }: Props) => {
  if (!el) return null

  const getTypeText = (type: PriceDocumentType) => {
    switch (type) {
      case PriceDocumentType.INIT:
        return 'Инициализация'
      case PriceDocumentType.SYNC:
        return 'Синхронизация'
      case PriceDocumentType.MANUAL:
        return 'Ручное изменение'
      case PriceDocumentType.IMPORT:
        return 'Импорт'
      case PriceDocumentType.CALCULATION:
        return 'Пересчет'
      default:
        return 'Документ'
    }
  }

  const totalSum = el.prices?.reduce((sum, p) => sum + (Number(p.price) || 0), 0) || 0

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div className={classes.title}>ДЕТАЛИ ДОКУМЕНТА ЦЕН</div>

        <div className={classes.row}>
          <div className={classes.id}>
            <div className={classes.label}>ТИП</div>
            <div className={classes.value}>{getTypeText(el.type)}</div>
          </div>
          <div className={classes.item}>
            <div className={classes.label}>НОМЕР</div>
            <div className={classes.value}>{el.number}</div>
          </div>
        </div>

        <div className={classes.row}>
          <div className={classes.item}>
            <div className={classes.label}>КОММЕНТАРИЙ</div>
            <div className={classes.value}>{el.comment || ''}</div>
          </div>
        </div>

        <div className={classes.title}>ПОЗИЦИИ</div>

        {el.prices?.map((price, idx) => (
          <div key={idx} className={classes.row}>
            <div className={classes.name}>
              <div className={classes.label}>НАИМЕНОВАНИЕ</div>
              <div className={classes.itemValue}>
                {price.item?.name || `Товар #${price.saleItemId}`}
              </div>
            </div>
            <div className={classes.item}>
              <div className={classes.label}>ЦЕНА</div>
              <div className={classes.itemValue}>{price.price} ₽</div>
            </div>
          </div>
        ))}

        <div className={classes.row}>
          <div className={classes.item}>
            <div className={classes.label}>ИТОГО ПОЗИЦИЙ</div>
            <div className={classes.value}>{el.prices?.length || 0}</div>
          </div>
          <div className={classes.item}>
            <div className={classes.label}>ОБЩАЯ СУММА</div>
            <div className={classes.value}>{totalSum} ₽</div>
          </div>
        </div>

        <div className={classes.row}>
          <div className={classes.item}>
            <div className={classes.label}>СОЗДАНО</div>
            <div className={classes.value}>
              {format(new Date(el.createdAt || ''), 'dd.MM.yyyy HH:mm')}
            </div>
          </div>
          {el.updatedAt && el.updatedAt !== el.createdAt && (
            <div className={classes.item}>
              <div className={classes.label}>ИЗМЕНЕНО</div>
              <div className={classes.value}>
                {format(new Date(el.updatedAt), 'dd.MM.yyyy HH:mm')}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
